import Navbar from "@/components/Navbar";
import NewsTicker from "@/components/NewsTicker";
import PoweredByStrava from "@/components/PoweredByStrava";
import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "@/lib/api";

const IGIcon = (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
  </svg>
);
const WAIcon = (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.5 14.4c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.6.1-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.2-.4-2.3-1.4-.9-.8-1.4-1.7-1.6-2-.2-.3 0-.5.1-.6.1-.1.3-.3.4-.5.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5-.1-.1-.6-1.6-.9-2.2-.2-.5-.5-.5-.6-.5h-.5c-.2 0-.5.1-.7.3-.3.3-1 1-1 2.4 0 1.4 1 2.8 1.2 3 .1.2 2 3.1 4.9 4.3.7.3 1.2.5 1.6.6.7.2 1.3.2 1.8.1.6-.1 1.7-.7 1.9-1.4.2-.7.2-1.2.2-1.4-.1-.1-.3-.2-.6-.3zM12 2C6.5 2 2 6.5 2 12c0 1.8.5 3.5 1.3 5L2 22l5.1-1.3c1.5.8 3.2 1.3 4.9 1.3 5.5 0 10-4.5 10-10S17.5 2 12 2z"/>
  </svg>
);
const StravaIcon = (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M15.387 17.944l-2.089-4.116h-3.065L15.387 24l5.15-10.172h-3.066m-7.008-5.599l2.836 5.598h4.172L10.463 0l-7 13.828h4.169"/>
  </svg>
);

function SocialLink({ href, icon, label, testId }) {
  if (!href) return null;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className="group inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.2em] uppercase text-zinc-400 hover:text-orange-500 transition"
    >
      <span className="group-hover:scale-110 transition">{icon}</span>
      {label}
    </a>
  );
}

export default function Layout() {
  const [s, setS] = useState({});
  useEffect(() => {
    api.get("/settings").then((r) => setS(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Navbar />
      <NewsTicker />
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="border-t border-zinc-800 bg-zinc-950 py-10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-display text-sm tracking-widest text-zinc-500">
            BORN IN ROURKELA · BUILT FOR ALL OF ODISHA
          </p>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <SocialLink href={s.instagram_oscr} icon={IGIcon} label="@odishasteelcityrunners" testId="footer-oscr-instagram" />
            <SocialLink href={s.instagram_founder} icon={IGIcon} label="@sumitsinghultrarunner" testId="footer-founder-instagram" />
            <SocialLink href={s.whatsapp_url} icon={WAIcon} label="WhatsApp" testId="footer-whatsapp" />
            <SocialLink href={s.strava_club_url} icon={StravaIcon} label="Strava Club" testId="footer-strava" />
            <SocialLink href={s.youtube_url} icon={<span className="text-[10px] font-display">YT</span>} label="YouTube" testId="footer-youtube" />
          </div>
          <p className="font-mono text-xs text-zinc-600">
            BUILT FOR ENDURANCE · {new Date().getFullYear()}
          </p>
        </div>
        <div className="max-w-7xl mx-auto px-5 sm:px-8 mt-6 pt-6 border-t border-zinc-900 flex justify-center">
          <PoweredByStrava size="md" />
        </div>
      </footer>
    </div>
  );
}
